//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChangePasswordDialogLayout from '@/frontend/components/common/change-password-dialog-layout.vue';
import {mapState, mapActions} from 'vuex'
export default {
  name: "header",
  components: {
    ChangePasswordDialogLayout
  },
  data() {
    return {
      changePasswordDialog: false,
      icon: undefined,
      logo: undefined,
      menuItems: [],
      mobileMenuOpen: false,
      facebookURL: null,
      linkedinURL: null,
      instagramURL: null
    }
  },
  computed: {
    ...mapState('shoppingCart', ['cartItemCount']),
    isChangePasswordRequired() {
      return this.$auth?.loggedIn && this.$auth?.user?.mustChangePasswordOnNextLogin
    },
    currentRoute() {
      return this.$route.path
    },
    customerName() {
      return this.$auth.user != null ? this.$auth.user.fullname : ''
    },
    isLoggerIn() {
      return this.$auth.loggedIn
    }
  },
  mounted(){
    this.getHeader()
    this.frontendGetBySessionId()
    if(this.$auth.loggedIn && this.$auth.user)
      this.changePasswordDialog = this.isChangePasswordRequired
  },
  methods: {
    ...mapActions('shoppingCart', ['frontendGetBySessionId']),
    toggleChildrenVisibility(item) {
      item.childrenVisible = item.childrenVisible === undefined ? true : !item.childrenVisible
      this.$forceUpdate() //sry but had to do it
    },
    async getHeader() {
      const headerData = (await this.$axios.get(`/contents/header`)).data

      this.icon = headerData?.details?.icon
      this.logo = headerData?.details?.logo
      this.menuItems = headerData?.details?.menu_items
      this.facebookURL = headerData?.details?.facebook_link?.fieldValue?.value
      this.instagramURL = headerData?.details?.instagram_link?.fieldValue?.value
      this.linkedinURL = headerData?.details?.linkedin_link?.fieldValue?.value
    },
  },
}
